module.exports = __webpack_public_path__ + "res/img_card_bg.16e50516f0e82a66e2adca0a955d3c7f.png";